export default __webpack_public_path__ + "static/media/Batch_Photos.cd1f9a1f.jpg";